import { render, staticRenderFns } from "./ProductConfiguratorEditorColor.vue?vue&type=template&id=c03939b0&functional=true&"
import script from "./ProductConfiguratorEditorColor.vue?vue&type=script&lang=js&"
export * from "./ProductConfiguratorEditorColor.vue?vue&type=script&lang=js&"
import style0 from "./ProductConfiguratorEditorColor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports